import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { FloatInput, FloatSelect, HeadPage } from "src/componentes";
import TributacaoCfopImpostoCadastroCode from "./TributacaoCfopImpostoCadastro.Code";

const TributacaoCfopImpostoCadastroView = () => {
  const {
    register,
    errors,
    handleSubmit,
    onSubmit,
    loading,
    getCstOptions,
    selectedCSTValue,
    handleCSTSelect,
  } = TributacaoCfopImpostoCadastroCode();

  return (
    <Container>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <HeadPage headText="Imposto Cadastro"></HeadPage>
        {!loading ? (
          <>
            <Row>
              <Col>
                <Col xs={12}>
                  <FloatSelect
                    label="CST/CSOSN"
                    options={getCstOptions()}
                    register={register("cst")}
                    errorsMessage={errors.cst}
                    tooltipMessage="Código tributário do imposto."
                    onSelect={handleCSTSelect}
                  />
                </Col>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {(() => {
                  switch (selectedCSTValue) {
                    case "101":
                      return (
                        <FloatInput
                          registerField={register("aliquotaSimples")}
                          label="Alíquota Simples"
                          errorsMessage={errors.aliquotaSimples}
                          inputMask="double"
                        />
                      );
                    case "2":
                      return <div>Exibindo conteúdo para a opção 2</div>;
                    case "3":
                      return <div>Exibindo conteúdo para a opção 3</div>;
                    default:
                      return (
                        <div>Selecione uma opção para ver o conteúdo.</div>
                      );
                  }
                })()}
              </Col>
            </Row>

            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default TributacaoCfopImpostoCadastroView;
